import Head from "next/head";
import dynamic from "next/dynamic";
const ItemsTierListPage = dynamic(
  () => import("../../../src/tier-list/ItemsTierListPage.tsx"),
  {
    ssr: false,
  },
);

export default function TraitsTierList() {
  return (
    <>
      <Head>
        <title>Items Tier List - TFT Set 17</title>
      </Head>
      <ItemsTierListPage />
    </>
  );
}
